module.exports = __webpack_public_path__ + "img/service_wechat_7.af0468c8.png";